const getRadioGroup = ($element: HTMLInputElement): HTMLInputElement[] => {
	if (!$element.form) return [$element];

	return Array.from(
		$element.form.querySelectorAll<HTMLInputElement>(`input[type="radio"][name="${$element.name}"]`),
	);
};

export function useGetValid($element: HTMLInputElement, options: OptionsVE): ResultVE {
	const result: ResultVE = {
		valid: false,
		error: false,
		message: '',
	};

	if ($element.type === 'radio') {
		if (options.noEmpty) {
			result.valid = true;
			result.error = false;
			return result;
		}

		const group = getRadioGroup($element);
		const isRequired = group.some((radio) => radio.required);
		const hasChecked = group.some((radio) => radio.checked);

		if (!isRequired) {
			result.valid = true;
			result.error = false;
			return result;
		}

		result.valid = hasChecked;
		result.error = !hasChecked;

		return result;
	}

	if (!options.noEmpty) {
		const valid = $element.checked;
		result.valid = valid;
		result.error = !valid;
	}

	return result;
}
